import { Sender } from 'xstate';

import asyncCallback from '@/framework/logic/utils/asyncCallback';
import GameFrameFrontend from '@/ports-frontend/GameFrame';
import MessageBus from '@/ports-frontend/MessageBus';

type GameActionsCallback = Sender<
  | {
      type: 'VIEW_SUGGESTED_GAMES_TILE_CLICK';
      payload: any;
    }
  | {
      type: 'TREBUCHET_PARTIAL_EVENT_CALLED';
      payload: any;
    }
  | {
      type: 'VIEW_CLOSE_GAME_MODAL';
    }
  | {
      type: 'GAME_SWITCHED';
      payload: any;
    }
  | {
      type: 'GAME_LAUNCH_REQUESTED';
      payload: any;
    }
>;

export const watchGameActions = () =>
  asyncCallback(async (callback: GameActionsCallback) => {
    const subscriptions: Function[] = [];

    subscriptions.push(
      await MessageBus.onSubscribe(
        () => callback({ type: 'VIEW_CLOSE_GAME_MODAL' }),
        ['wh.common.command.ui.game.close']
      ),

      await MessageBus.onSubscribe(
        data =>
          callback({
            type: 'VIEW_SUGGESTED_GAMES_TILE_CLICK',
            payload: data.payload,
          }),
        ['wh.common.event.game.changed']
      ),

      await MessageBus.onSubscribe(
        data =>
          callback({
            type: 'GAME_LAUNCH_REQUESTED',
            payload: data.payload,
          }),
        ['wh.common.command.game.launch']
      ),

      await MessageBus.onSubscribe(
        data =>
          callback({
            type: 'TREBUCHET_PARTIAL_EVENT_CALLED',
            payload: data.payload,
          }),
        ['wh.trebuchet.command.tracking.partial']
      ),

      await MessageBus.onSubscribe(
        data =>
          callback({
            type: 'GAME_SWITCHED',
            payload: data.payload,
          }),
        ['wh.trebuchet.gameSwitched']
      ),

      await MessageBus.onSubscribe(() => {
        GameFrameFrontend.exitFullscreen();
      }, ['wh.trebuchet.command.game.fullscreen.exit'])
    );

    return () => {
      subscriptions.forEach(unsub => unsub());
    };
  });
